<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->

<!-- Filter Panel -->
<div class="filter-panel">
  <div class="filter-header">
    <div class="filter-title">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
        />
      </svg>
      Reseller Filters
    </div>
    <div class="filter-actions">
      <button [disabled]="!isFilterApplied()" class="clear-btn" (click)="clearFilter()">
        Clear All
      </button>
      <button class="add-reseller-btn" (click)="onAddReseller()">
        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
          />
        </svg>
        Add Reseller
      </button>
    </div>
  </div>

  <div class="filter-content">
    <!-- Search -->
    <div class="search-box">
      <svg
        class="search-icon"
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
      <input
        type="text"
        class="search-input"
        placeholder="Search by name, email or mobile number..."
        [value]="searchTerm()"
        (input)="onSearch($event.target.value)"
      />
    </div>

    <!-- Group Filters -->
    <!-- Removed AIS Price Group Filter -->
  </div>
</div>

@if (!isLoading() && resellers().length) {
  <div class="table-card">
    <div class="table-responsive">
      <table class="data-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Country</th>
            <th>Mobile</th>
            <th>Company</th>
            <th>Credit Limit (฿)</th>
            <th>Packages</th>
            <th>Sender IDs</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (reseller of resellers(); track reseller.email) {
            <tr>
              <td>{{ reseller.firstName + ' ' + reseller.lastName }}</td>
              <td>{{ reseller.email }}</td>
              <td>{{ reseller.country }}</td>
              <td>{{ reseller.mobile }}</td>
              <td>{{ reseller.company }}</td>
              <td>{{ reseller.smsCreditLimit | number: '1.0-0' }}</td>
              <td>{{ reseller.packageNames }}</td>
              <td>{{ reseller.senderIdNames }}</td>
              <td>
                <div class="action-btns">
                  <button class="edit-btn" (click)="onEdit(reseller)">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </button>
                  <button class="delete-btn" (click)="onDelete(reseller)">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      [totalItems]="totalItems()"
      [pageSize]="pageSize()"
      [currentPage]="currentPage()"
      itemName="resellers"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    />
  </div>
}

@if (!isLoading() && !resellers().length) {
  <app-data-not-found [message]="'No resellers found'" />
}

@if (isLoading()) {
  <app-loader />
}

<!-- Add Reseller Modal -->
@if (isModalOpen()) {
  <div
    class="modal-backdrop"
    (click)="closeModal()"
    (keydown.escape)="closeModal()"
    role="button"
    tabindex="0"
  >
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">{{ isEditMode() ? 'Edit Reseller' : 'Add New Reseller' }}</h2>
        <button class="close-modal-btn" (click)="closeModal()">
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <form class="modal-form" [formGroup]="resellerForm" (ngSubmit)="saveReseller()">
        <div class="modal-body">
          <div class="form-grid">
            <!-- Name Row -->
            <div class="form-row name-row">
              <div class="form-group">
                <label for="firstName">First Name</label>
                <div class="input-wrapper">
                  <input
                    id="firstName"
                    type="text"
                    formControlName="firstName"
                    placeholder="First name"
                    class="form-input"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="lastName">Last Name</label>
                <div class="input-wrapper">
                  <input
                    id="lastName"
                    type="text"
                    formControlName="lastName"
                    placeholder="Last name"
                    class="form-input"
                  />
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="form-group full-width">
              <label for="email">Email Address</label>
              <div class="input-wrapper">
                <input
                  id="email"
                  type="email"
                  formControlName="email"
                  placeholder="Enter email address"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Company -->
            <div class="form-group full-width">
              <label for="company">Company</label>
              <div class="input-wrapper">
                <input
                  id="company"
                  type="text"
                  formControlName="company"
                  placeholder="Enter company name"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Country & Mobile -->
            <div class="form-row">
              <div class="form-group">
                <label for="country">Country</label>
                <div class="input-wrapper">
                  <input
                    id="country"
                    type="text"
                    formControlName="country"
                    placeholder="Country"
                    class="form-input"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="mobile">Mobile</label>
                <div class="input-wrapper">
                  <input
                    id="mobile"
                    type="text"
                    formControlName="mobile"
                    placeholder="Mobile number"
                    class="form-input"
                  />
                </div>
              </div>
            </div>

            <!-- Credit Limit -->
            <div class="form-group full-width">
              <label for="smsCreditLimit">Credit Limit (฿)</label>
              <div class="input-wrapper">
                <input
                  id="smsCreditLimit"
                  type="number"
                  formControlName="smsCreditLimit"
                  placeholder="0.00"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Password -->
            @if (!isEditMode()) {
              <div class="form-group full-width">
                <label for="password">Password</label>
                <div class="input-wrapper">
                  <input
                    id="password"
                    [type]="showPassword() ? 'text' : 'password'"
                    formControlName="password"
                    placeholder="Enter password"
                    class="form-input"
                  />
                  <button
                    type="button"
                    class="password-toggle"
                    (click)="togglePasswordVisibility()"
                  >
                    @if (showPassword()) {
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18"
                        />
                      </svg>
                    } @else {
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    }
                  </button>
                </div>
              </div>
            }

            <!-- Package -->
            <div class="form-group full-width">
              <label for="package">Package</label>
              <div class="custom-multiselect" [class.open]="isPackageDropdownOpen()">
                <div class="multiselect-trigger" (click)="togglePackageDropdown($event)">
                  <span class="trigger-text">
                    @if (resellerForm.get('package')?.value?.length) {
                      {{ getSelectedPackageNames() }}
                    } @else {
                      Select Packages
                    }
                  </span>
                  <svg
                    class="trigger-arrow"
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                <div class="multiselect-dropdown" (click)="$event.stopPropagation()">
                  @for (group of packages(); track group._id) {
                    <div
                      class="multiselect-option"
                      [class.selected]="isPackageSelected(group.name)"
                      (click)="togglePackageSelection(group.name)"
                    >
                      <div class="option-checkbox">
                        @if (isPackageSelected(group.name)) {
                          <svg
                            width="12"
                            height="12"
                            fill="none"
                            stroke="white"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="3"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        }
                      </div>
                      <span class="option-label">{{ group.name }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>

            <!-- Sender ID -->
            <div class="form-group full-width">
              <label for="senderId">Sender ID</label>
              <div class="input-wrapper">
                <input
                  id="senderId"
                  type="text"
                  formControlName="senderId"
                  placeholder="Enter sender ID"
                  class="form-input"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="modal-btn cancel" (click)="closeModal()">Cancel</button>
          <button type="submit" class="modal-btn save">
            {{ isEditMode() ? 'Update Reseller' : 'Save Reseller' }}
          </button>
        </div>
      </form>
    </div>
  </div>
}

<!-- Delete Confirmation Modal -->
@if (isDeleteModalOpen()) {
  <div
    class="modal-backdrop"
    (click)="closeDeleteModal()"
    (keydown.escape)="closeDeleteModal()"
    role="button"
    tabindex="0"
  >
    <div class="modal-container delete-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Confirm Deletion</h2>
        <button class="close-modal-btn" (click)="closeDeleteModal()">
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body text-center">
        <div class="delete-icon-wrapper">
          <svg width="48" height="48" fill="none" stroke="#ef4444" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </div>
        <p class="delete-message">
          Are you sure you want to delete
          <strong>{{ resellerToDelete()?.firstName + ' ' + resellerToDelete()?.lastName }}</strong
          >? This action cannot be undone.
        </p>
      </div>

      <div class="modal-footer">
        <button type="button" class="modal-btn cancel" (click)="closeDeleteModal()">
          No, Keep it
        </button>
        <button type="button" class="modal-btn delete" (click)="confirmDelete()">
          Yes, Delete Reseller
        </button>
      </div>
    </div>
  </div>
}
